import script from "./LetterTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterTile.vue?vue&type=script&setup=true&lang=ts"

import "./LetterTile.vue?vue&type=style&index=0&id=e313fdb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e313fdb0"]])

export default __exports__